/* prettier-ignore-start */

/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file is auto-generated by TanStack Router

import { createFileRoute } from '@tanstack/react-router'
import { Route as rootRoute } from './routes/__root'
import { Route as AccountRouteImport } from './routes/account'
import { Route as ExpressCheckoutRouteImport } from './routes/express-checkout'
import { Route as PlansRouteImport } from './routes/plans'
import { Route as PriceTableRouteImport } from './routes/price-table'
import { Route as PrivacyRouteImport } from './routes/privacy'
import { Route as TermsRouteImport } from './routes/terms'
import { Route as IndexRouteImport } from './routes/index'

// Create/Update Routes

const AccountRoute = AccountRouteImport.update({
  path: '/account',
  getParentRoute: () => rootRoute,
} as any)

const ExpressCheckoutRoute = ExpressCheckoutRouteImport.update({
  path: '/express-checkout',
  getParentRoute: () => rootRoute,
} as any)

const PlansRoute = PlansRouteImport.update({
  path: '/plans',
  getParentRoute: () => rootRoute,
} as any)

const PriceTableRoute = PriceTableRouteImport.update({
  path: '/price-table',
  getParentRoute: () => rootRoute,
} as any)

const PrivacyRoute = PrivacyRouteImport.update({
  path: '/privacy',
  getParentRoute: () => rootRoute,
} as any)

const TermsRoute = TermsRouteImport.update({
  path: '/terms',
  getParentRoute: () => rootRoute,
} as any)

const IndexRoute = IndexRouteImport.update({
  path: '/',
  getParentRoute: () => rootRoute,
} as any)

// Populate the FileRoutesByPath interface

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRoute
    }
    '/account': {
      id: '/account'
      path: '/account'
      fullPath: '/account'
      preLoaderRoute: typeof AccountRouteImport
      parentRoute: typeof rootRoute
    }
    '/express-checkout': {
      id: '/express-checkout'
      path: '/express-checkout'
      fullPath: '/express-checkout'
      preLoaderRoute: typeof ExpressCheckoutRouteImport
      parentRoute: typeof rootRoute
    }
    '/plans': {
      id: '/plans'
      path: '/plans'
      fullPath: '/plans'
      preLoaderRoute: typeof PlansRouteImport
      parentRoute: typeof rootRoute
    }
    '/price-table': {
      id: '/price-table'
      path: '/price-table'
      fullPath: '/price-table'
      preLoaderRoute: typeof PriceTableRouteImport
      parentRoute: typeof rootRoute
    }
    '/privacy': {
      id: '/privacy'
      path: '/privacy'
      fullPath: '/privacy'
      preLoaderRoute: typeof PrivacyRouteImport
      parentRoute: typeof rootRoute
    }
    '/terms': {
      id: '/terms'
      path: '/terms'
      fullPath: '/terms'
      preLoaderRoute: typeof TermsRouteImport
      parentRoute: typeof rootRoute
    }
  }
}

// Create and export the route tree

export const routeTree = rootRoute.addChildren({ IndexRoute, AccountRoute, ExpressCheckoutRoute, PlansRoute, PriceTableRoute, PrivacyRoute, TermsRoute })

/* prettier-ignore-end */